module.exports = __webpack_public_path__ + "static/media/band-aid.eac59dbf.svg";